module.exports = __webpack_public_path__ + "static/img/js3.f543403.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/js3.png
// module id = BEkJ
// module chunks = 1